import { newToolFilterOAuthMcp } from "../oauth.ts";

export const bitlyMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://d1ayxb9ooonjts.cloudfront.net/web_sign_up_sign_in/1f339ebb-06fb-4b50-9e41-d7de83162b19/images/favicon.svg",
  url: "https://api-ssl.bitly.com/v4/mcp",
  label: "Bitly",
});
